var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg002Align(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 48,
    viewBox: "0 0 60 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_002-align",
    "data-name": "002-align",
    transform: "translate(-2 -4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_80163",
    "data-name": "Path 80163",
    d: "M25,17a3,3,0,0,0,0-6H19v6Z",
    transform: "translate(34 14)",
    fill: "#02fdb1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80164",
    "data-name": "Path 80164",
    d: "M28,4H16a3,3,0,0,0-3,3V49a3,3,0,0,0,3,3H28a3,3,0,0,0,3-3V7A3,3,0,0,0,28,4Z",
    transform: "translate(22)",
    fill: "#12784a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80165",
    "data-name": "Path 80165",
    d: "M5,11a3,3,0,0,0,0,6h6V11Z",
    transform: "translate(0 14)",
    fill: "#02fdb1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80166",
    "data-name": "Path 80166",
    d: "M8,7H20a3,3,0,0,1,3,3V34a3,3,0,0,1-3,3H8a3,3,0,0,1-3-3V10A3,3,0,0,1,8,7Z",
    transform: "translate(6 6)",
    fill: "#3bbf83"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg002Align);
export default __webpack_public_path__ + "static/media/002-align.c9d98b26792c9be0457efefdff38ca14.svg";
export { ForwardRef as ReactComponent };